/**
 * Checks whether the options has params.
 *
 * @param options The options.
 */
export function hasParams(options) {
    return options.params !== undefined;
}
